import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy, Suspense } from 'react';
import App from "./App";
import { useAuthStore } from "./stores/auth.store";
import { ProtectedRoute } from "./components/shared/ProtectedRoute";
import LoadingFallback from "./components/shared/LoadingFallback";
import Verify from "./pages/subscription/Verify";
import ConfirmationAccount from "./pages/subscription/Confirmation-account";
import ResetPassword from "./pages/subscription/Reset-password";

// Lazy load all the page components with default exports
const About = lazy(() => import("./pages/about/About"));
const Clientes = lazy(() => import("./pages/clientes"));
const TipoPedidoPage = lazy(() => import("./pages/tipo-pedido"));
const FamiliaProductoPage = lazy(() => import("./pages/familia-producto"));
const BodegaPage = lazy(() => import("./pages/bodega"));
const AuthValidator = lazy(() => import("./pages/authvalidator"));
const Dashboard = lazy(() => import("./pages/Dashboard"));

const MarcaPage = lazy(() => import("./pages/marca"));
const TipoProductoPage = lazy(() => import("./pages/tipoProducto"));
const TestApp = lazy(() => import("./pages/testapp/page"));

// Lazy load components with named exports
const LandingPage = lazy(() => import('./pages/LandingPage/LandingPage').then(module => ({ default: module.LandingPage })));
const Onboarding = lazy(() => import('./pages/onBoarding/Onboarding').then(module => ({ default: module.Onboarding })));




// Component that renders based on authentication status at the root level
const RootRedirect = () => {
  const { isLoggedIn } = useAuthStore();
  return isLoggedIn ? <Navigate to="/dashboard" replace /> : <Suspense fallback={<LoadingFallback />}><LandingPage /></Suspense>;
};

export const router = createBrowserRouter([
  // Root route shows LandingPage when not authenticated, redirects to dashboard when authenticated
  { 
    path: "/", 
    element: <RootRedirect /> 
  },
  // App layout route with nested protected routes
  { 
    path: "/",
    element: <App />,
    children: [
      // Dashboard route (protected)
      { 
        path: "dashboard", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><Dashboard /></Suspense>
          </ProtectedRoute>
        ) 
      },
      // All other routes are protected and will render inside the App layout
      { 
        path: "about", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><About /></Suspense>
          </ProtectedRoute>
        ) 
      },
      { 
        path: "clientes", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><Clientes /></Suspense>
          </ProtectedRoute>
        ) 
      },
      { 
        path: "tipo-pedidos", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><TipoPedidoPage /></Suspense>
          </ProtectedRoute>
        ) 
      },
      { 
        path: "familia-productos", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><FamiliaProductoPage /></Suspense>
          </ProtectedRoute>
        ) 
      },
      { 
        path: "bodegas", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><BodegaPage /></Suspense>
          </ProtectedRoute>
        ) 
      },
      { 
        path: "marcas", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><MarcaPage /></Suspense>
          </ProtectedRoute>
        ) 
      },
      { 
        path: "tipo-productos", 
        element: (
          <ProtectedRoute>
            <Suspense fallback={<LoadingFallback />}><TipoProductoPage /></Suspense>
          </ProtectedRoute>
        ) 
      },
      { 
        path: "auth-validator", 
        element: (
          <Suspense fallback={<LoadingFallback />}><AuthValidator /></Suspense>
        ) 
      },
      { 
        path: "onboarding", 
        element: (
          <Suspense fallback={<LoadingFallback />}><Onboarding /></Suspense>
        ) 
      },
      { 
        path: "test", 
        element: (
          <Suspense fallback={<LoadingFallback />}><TestApp /></Suspense>
        ) 
      },
            { 
        path: "subscription/verify", 
        element: (
          <Suspense fallback={<LoadingFallback />}><Verify /></Suspense>
        ) 
      },
      { 
        path: "/confirmation-account", 
        element: (
          <Suspense fallback={<LoadingFallback />}><ConfirmationAccount /></Suspense>
        ) 
      },
      { 
        path: "/reset-password", 
        element: (
          <Suspense fallback={<LoadingFallback />}><ResetPassword /></Suspense>
        ) 
      },

    ]
  },
]);